export const getLocationFinalName = (location?: {
    name: string;
    shortName?: string;
    displayName?: string;
}) => {
    return (
        location?.displayName ??
        location?.shortName ??
        location?.name
    )?.toUpperCase();
};
